import moment from "moment";

const isObject = (item) =>
	item && typeof item === "object" && !Array.isArray(item);

export const mergeDeep = (target, source, { ignoreKeys = [] } = {}) => {
	let result;
	if (isObject(target)) {
		result = { ...target };
	}
	if (Array.isArray(target)) {
		result = [...target];
	}
	if (
		(isObject(target) && isObject(source)) ||
		(Array.isArray(target) && Array.isArray(source))
	) {
		for (const key in source) {
			if (ignoreKeys.includes(key)) {
				result[key] = source[key];
				continue;
			}
			if (Array.isArray(source[key])) {
				if (!result[key]) {
					result[key] = [];
				}
				result[key] = mergeDeep(result[key], source[key]);
				continue;
			}
			if (isObject(source[key]) && !moment.isMoment(source[key])) {
				if (!result[key]) {
					result[key] = {};
				}
				result[key] = mergeDeep(result[key], source[key]);
				continue;
			}
			result[key] = source[key];
		}
	}
	return result;
};
